<template>
    <div v-if="millesime" class="d-flex flex-column my-5 container">
        
        <div class="col d-flex flex-column justify-content-between ">
            <h4 class="mb-2" style="margin-left: -11px;">Quelques données Synthétiques <span style="font-size:1rem;">
                    ( <span class="text-primary">{{ millesimeRef.title }}</span> )</span>
            </h4>
            <div class="row w-100 p-3 mb-2" style="font-size: 0.73rem; padding-bottom: -10px; font-style: italic; background-color: #ff00000a;border: #ff000036 1px solid;     border-radius: 13px 0 15px 0;">
                    <p style="margin-bottom: 0.5rem;">
                        <svg style="color: #d10056;" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                            <!-- Icon from Bootstrap Icons by The Bootstrap Authors - https://github.com/twbs/icons/blob/main/LICENSE.md -->
                             <g fill="currentColor"><path d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134z"/><path d="M7.002 11a1 1 0 1 1 2 0a1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/></g></svg>
                Deux évolutions importantes des données utilisées dans la construction de l'indicateur PPPI ont eu lieu entre <span style="font-weight: bold;"> les millésimes 2019 et 2021</span> et doivent conduire à une grande prudence dans l'interprétation des résultats du PPPI. 
                    </p>
                    <p style="margin-bottom: 0.5rem;">
                    D'une part, <span style="font-weight: bold;"> suite à la fin de la taxe d'habitation</span>, la méthode de construction des données de revenu a été modifiée pour s'appuyer sur une autre source fiscale, plus fiable, conduisant à une baisse très importante du nombre de ménages avec un revenu de 0, au profit du nombre de ménages sans revenus connus (605 232 revenus non renseignés en 2019 contre 1 339 947 en 2021). Cette baisse induit mécaniquement une forte baisse du nombre de logements PPPI. 
                    </p>
                    <p style="margin-bottom: 0.5rem;">    D'autre part, des données <span style="font-weight: bold;">apparaissent dans les DROM à partir du millésime 2021</span>, mais les données fiscales y sont renseignées de manière beaucoup moins systématiques qu'en France métropolitaine, et donnent lieu à des résultats très différents. 
                        <br>
                        Chacune de ces évolutions est décrite de manière plus détaillée dans <a class="" href="/pppi_doc/1">la note méthodologique disponible dans la section documentation</a>.
                    </p>
            </div>
        </div>
        <div class="d-flex content-justify-start align-items-center">
            <h5 class="font-weight-bold text-secondary mt-4 col-4">
                Territoire : 
            </h5>
            <div class="col-8">
                <div class="form-row">
                    <div class="col-4">
                        <select class="form-control font-weight-bold" v-model="selectedTerritoryType2"
                            @change="resetTerritorySearchPrimary">

                            <option v-for="type in territoryTypes" :key="type.value" :value="type.value">
                                {{ type.label }}
                            </option>
                        </select>
                    </div>
                    <div class="col-8 position-relative">
                        <input type="text" class="form-control font-weight-bold"
                            :placeholder="`Rechercher une ${territoryTypeLabel2}`" v-model.trim="territorySearchTerm2"
                            @input="scheduleTerritorySearchPrimary" />
                        <div v-if="isSearchingTerritory2"
                            class="spinner-border spinner-border-sm text-primary territory-search-spinner"></div>
                        <ul v-if="territorySuggestions2.length" class="list-group territory-suggestions">
                            <li v-for="suggestion in territorySuggestions2" :key="suggestion.code"
                                class="list-group-item list-group-item-action"
                                @click="handleTerritorySuggestionSelectPrimary(suggestion)">
                                {{ suggestion.nom }} ({{ suggestion.code }})
                            </li>
                        </ul>
                    </div>
                </div>
                <small v-if="territorySearchError2" class="text-danger">
                    {{ territorySearchError2 }}
                </small>
            </div>  
        </div>
        <div v-if="displayTerrRef[0] && displayTerrRef[0].label" class="d-flex flex-row col-12 stick-label-stats">
                {{displayTerrRef[0].label }} ({{displayTerrRef[0].code}})
        </div> 
        <Loading v-if="loading" />
        <div v-if="stats && Array.isArray(stats) && stats.length > 0" class="row no-gutters row-cols-1 row-cols-md-2 row-cols-lg-6">
            <div v-for="stat in stats" :key="stat.id" :class="`${stat.is_double ? 'col col-lg-4' : 'col'} p-1`">
                <PppiBlocStat :outlined="false" :double="stat.is_double" :column="stat.is_column"  :stattype="stat.typeref" :title="stat.title"
                    :ref-indic="stat.ref" :src="stat.src" :color="stat.color" :val="stat.val.refData" />
            </div>
        </div>
        <div v-if="stats.length && stats.length > 0" class="row cols-6 h-4">
            <div class="col d-flex flex-column flex-md-row justify-content-between align-items-center mt-1 mb-5">
                <div class="d-flex align-items-center mb-3 sm:mb-0">
                    <div class="btn btn-sm btn-outline-primary bloc_stat-csv-btn mr-2" @click="dowloadDataAsCSVFile">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                            <path fill="currentColor"
                                d="M15 9H5V5h10m-3 14a3 3 0 0 1-3-3a3 3 0 0 1 3-3a3 3 0 0 1 3 3a3 3 0 0 1-3 3m5-16H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7l-4-4Z" />
                        </svg>
                    </div>
                    <div class="text-sm">Télécharger ces données de synthèse</div>
                </div>
            </div>
        </div>

        <div class="d-flex content-justify-start align-items-center">
            <h5 class="font-weight-bold text-secondary mt-4 col-4">
                Territoire de référence : 
            </h5>
            <div class="col-8">
                <div class="form-row">
                    <div class="col-4">
                        <select class="form-control font-weight-bold" v-model="selectedTerritoryType"
                            @change="resetTerritorySearch">
                            <option v-for="type in territoryTypes" :key="type.value" :value="type.value">
                                {{ type.label }}
                            </option>
                        </select>
                    </div>
                    <div class="col-8 position-relative">
                        <input type="text" class="form-control font-weight-bold"
                            :placeholder="`Rechercher une ${territoryTypeLabel}`" v-model.trim="territorySearchTerm"
                            @input="scheduleTerritorySearch" />
                        <div v-if="isSearchingTerritory"
                            class="spinner-border spinner-border-sm text-primary territory-search-spinner"></div>
                        <ul v-if="territorySuggestions.length" class="list-group territory-suggestions">
                            <li v-for="suggestion in territorySuggestions" :key="suggestion.code"
                                class="list-group-item list-group-item-action"
                                @click="handleTerritorySuggestionSelect(suggestion)">
                                {{ suggestion.nom }} ({{ suggestion.code }})
                            </li>
                        </ul>
                    </div>
                </div>
                <small v-if="territorySearchError" class="text-danger">
                    {{ territorySearchError }}
                </small>
            </div>
        </div>
        <div v-if="displayTerrRef[1] && displayTerrRef[1].label" class="d-flex flex-row col-12 stick-label-stats">
                {{displayTerrRef[1].label }} ({{displayTerrRef[1].code}})
        </div>
        <Loading v-if="loading2" />
        <div v-else-if="stats2.length && stats2.length > 0"
            class="row no-gutters row-cols-1 row-cols-md-2 row-cols-lg-6">
            <div v-for="statVal in stats2" :key="statVal.id"
                :class="`${statVal.is_double ? 'col col-md-2 col-lg-4' : 'col'} p-1`">
                <PppiBlocStat :outlined="true" :double="statVal.is_double" :column="statVal.is_column" :stattype="statVal.typeref"
                    :ref-indic="statVal.ref" :src="statVal.src" :title="statVal.title" :color="statVal.color"
                    :val="statVal.val.refData" />
            </div>
        </div>
        <div v-else class="d-flex flex-column my-5 container">
            <p>Désolé. Les données ne sont actuellement pas disponible pour ce territoire</p>
        </div>
        <div v-if="stats2.length && stats2.length > 0" class="row cols-6 h-4">
            <div class="col d-flex flex-column flex-md-row justify-content-between align-items-center mt-1 mb-5">
                <div class="d-flex align-items-center mb-3 sm:mb-0">
                    <div class="btn btn-sm btn-outline-primary bloc_stat-csv-btn mr-2" @click="dowloadDataAsCSVFile(2)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                            <path fill="currentColor"
                                d="M15 9H5V5h10m-3 14a3 3 0 0 1-3-3a3 3 0 0 1 3-3a3 3 0 0 1 3 3a3 3 0 0 1-3 3m5-16H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7l-4-4Z" />
                        </svg>
                    </div>
                    <div class="text-sm">Télécharger ces données de cadrage</div>
                </div>
                <a href="/pppi_export/1" class="btn btn-primary">
                    <i class="fa fa-cloud-download text-white mr-1" aria-hidden="true"></i>
                    Télécharger l'intégralité des données pour votre territoire
                </a>
            </div>
        </div>
    </div>

</template>

<script>
import PppiBlocStat from './PppiBlocStat.vue';
import Loading from '../Loading.vue';
import PppiService from '../../services/PppiService';
import CogApiService from '../../services/CogApiService';

const cogApiService = new CogApiService();

export default {
    name: "pppi_stats",
    props: ['tag', 'terrLevelSelected', 'terrCodeSelected', 'terrLabelSelected', 'millesime', 'section'],
    components: {
        PppiBlocStat,
        Loading
    },
    data: function () {
        return {
            loading: false,
            loading2: false,
            terrRef: [
                {
                    "code": '01',
                    "label": 'Ain',
                    "level": 'dep'
                }
            ],
            data: [],
            data2: [],
            stats: [],
            stats2: [],
            listTerrs: [],
            displayTerrRef: [],
            selectedCodeTerr: '',
            selectedLabelTerr: '',
            terrLevelRef: '',
            terrNameRef: '',
            millesimeRef: '',
            refsReference: [],
            refsVal: null,
            refsVal2: null,
            pppiService: null,
            userPerims: null,
            terrLabelTitleSelected: null,
            ept_coms: null,
            multiCodes: null,
            terrLevel: null,
            terrCode: null,
            terrLabel: null,
            purData: null,
            territoryTypes: [                    
                { value: 'dep', label: 'Département' },
                { value: 'epci', label: 'EPCI' },
                { value: 'com', label: 'Commune' }
            ],
            selectedTerritoryType: 'dep',
            selectedTerritoryType2: 'dep',
            territorySearchTerm: '',
            territorySearchTerm2: '',
            territorySuggestions: [],
            territorySuggestions2: [],
            territorySearchTimeout: null,
            territorySearchTimeout2: null,
            isSearchingTerritory: false,
            isSearchingTerritory2: false,
            territorySearchError: '',
            territorySearchError2: '',
            lastTerritorySearchSignature: '',
            lastTerritorySearchSignature2: '',
            
        }
    },
    computed: {
        territoryTypeLabel() {
            const currentType = this.territoryTypes.find(t => t.value === this.selectedTerritoryType);
            return currentType ? currentType.label.toLowerCase() : 'territoire';
        },
        territoryTypeLabel2() {
            const currentType = this.territoryTypes.find(t => t.value === this.selectedTerritoryType2);
            return currentType ? currentType.label.toLowerCase() : 'territoire';
        }
    },
    mounted() {
        this.pppiService = new PppiService();
        this.millesimeRef = JSON.parse(this.millesime);
        /*
        this.userPerims = JSON.parse(this.dfperims);
        this.terrLabel = this.terrLabelSelected;
        this.terrCode = this.terrCodeSelected;
        this.terrLevel = this.terrLevelSelected;
        */
       //console.log("perims : ", this.terrLevelSelected, this.terrCodeSelected, this.terrLabelSelected);
        
        this.terrLabelTitleSelected = "Région ";
        this.buildDFPerims();

        //console.log(localStorage.currentsection, this.section);

        if (localStorage.currentsection !== 'pppi' && this.section === 'pppi') {
            $("#convModal").modal('show');
            localStorage.currentsection = 'pppi';
        }
        this.pppiService.getRefs("synthetic").then(result => {
            this.refsReference = Array.from(JSON.parse(JSON.stringify(result)));
            this.refsVal = Array.from(JSON.parse(JSON.stringify(result)));
            this.refsVal2 = Array.from(JSON.parse(JSON.stringify(result)));
            this.buildUserLevel();
        })
    },
    methods: {
        persist() {
            localStorage.currentsection = this.section;
        },
        buildDFPerims: function (refPerims) {
               return { "level": this.terrLevelSelected, "code": this.terrCodeSelected, "label": this.terrLabelSelected }
        },
        buildUserLevel: function () {
            //console.log("buildUserLevel", this.terrLevelSelected);
            this.terrLevelRef = "dep";
            this.terrNameRef = "Département";
            axios.get(`https://geo.api.gouv.fr/regions/${this.terrCodeSelected}/departements?fields=nom,code,region`)
                        .then((result) => {
                            //console.log("reg result", result.data);
                            this.terrLabelSelected = result.data[0].region.nom;// nom de la région 
                            this.listTerrs = result.data;
                            this.selectedCodeTerr = result.data[0].code;
                            this.selectedLabelTerr = result.data[0].nom;
                            this.getData(result.data[0].code, 'dep', 1);
                            this.territorySuggestions2 = result.data[0].code;
                            this.handleTerritorySuggestionSelectPrimary({'nom': result.data[0].nom, 'code': result.data[0].code,});
                           
                            // fire seconde territory search !
                            this.territorySuggestions = result.data[1].code
                            this.handleTerritorySuggestionSelect({'nom': result.data[1].nom, 'code': result.data[1].code,})
                        })
            this.selectedTerritoryType = this.terrLevelRef || this.selectedTerritoryType;

        },
        getData: function (inseeCode, terrLevel, order = 1, label = null) {
            order === 1 ? this.loading = true : null;
            order === 2 ? this.loading2 = true : null;
            let that = this;
            //console.log("getData", inseeCode, terrLevel, order);
            axios.post('/api/pppi/stats', { "code": inseeCode, "level": terrLevel, "thema": "synthetic" }).then((result) => {
                // L'API retourne un tableau avec un seul élément, on prend le premier
                const dataValue = Array.isArray(result.data) ? result.data[0] : result.data;
                if (order === 1) {
                    this.purData = dataValue;
                    this.stats = that.pppiService.mergeData(dataValue, that.refsVal, order)
                } else {
                    this.stats2 = that.pppiService.mergeData(dataValue, that.refsVal2, order)
                }
                
            }).catch((error) => {
                console.log('PppiStats.vue getData error', error);
            }).finally(() => {
                order === 1 ? this.loading = false : null;
                order === 2 ? this.loading2 = false : null;
                order === 1 ? this.displayTerrRef[0] = {"code": inseeCode, "label": label, "level": terrLevel} : null;
                order === 2 ? this.displayTerrRef[1] = {"code": inseeCode, "label": label, "level": terrLevel} : null;
            });
        },
        dowloadDataAsCSVFile: function (order = 1) {

            let text = "";
            for (const [key, value] of Object.entries(this.purData)) {
                console.log(key, value);
                text += `${key};${value}\n`;
            }
            let filename = 'pppi_tabl_cadrage_' + this.terrCodeSelected + '.csv';
            let element = document.createElement('a');
            element.setAttribute('href', 'data:application/csv;charset=utf-8,' + encodeURIComponent(text));
            element.setAttribute('download', filename);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        },
        handleRefChange: function (code, level, label) {
            this.stats2 = Array.from(JSON.parse(JSON.stringify(this.refsReference)));
            this.getData(this.selectedCodeTerr, this.terrLevelRef, 2 ,label);
           

        },
        scheduleTerritorySearchPrimary() {
            clearTimeout(this.territorySearchTimeout2);
            const trimmedTerm = this.territorySearchTerm2 ? this.territorySearchTerm2.trim() : '';
            if (!trimmedTerm || trimmedTerm.length < 2) {
                this.territorySuggestions2 = [];
                this.lastTerritorySearchSignature2 = '';
                return;
            }
            const searchSignature = this.createSearchSignature(trimmedTerm, this.selectedTerritoryType2);
            if (searchSignature === this.lastTerritorySearchSignature2) {
                return;
            }
            this.territorySearchTimeout2 = setTimeout(() => {
                this.fetchTerritorySuggestionsPrimary(trimmedTerm, this.selectedTerritoryType2, searchSignature);
            }, 300);
        },
        async fetchTerritorySuggestionsPrimary(term, type, signature) {
            this.isSearchingTerritory2 = true;
            this.territorySearchError2 = '';
            this.lastTerritorySearchSignature2 = signature;
            try {
                const { url, params } = this.buildGeoApiSearchQuery(type, term);
                const { data } = await axios.get(url, { params });
                const currentSignature = this.createSearchSignature(
                    this.territorySearchTerm2 ? this.territorySearchTerm2.trim() : '',
                    this.selectedTerritoryType2
                );
                if (signature !== currentSignature) {
                    return;
                }
                this.territorySuggestions2 = Array.isArray(data) ? data.slice(0, 10) : (data ? [data] : []);
            } catch (error) {
                console.error('Territory search error', error);
                this.territorySearchError2 = "Impossible de récupérer les suggestions.";
                this.territorySuggestions2 = [];
            } finally {
                this.isSearchingTerritory2 = false;
            }
        },
        handleTerritorySuggestionSelectPrimary(suggestion) {
            this.terrCodeSelected = suggestion.code;
            this.terrLabelSelected = suggestion.nom;
            this.territorySearchTerm2 = `${suggestion.nom} (${suggestion.code})`;
            this.lastTerritorySearchSignature2 = this.createSearchSignature(
                this.territorySearchTerm2.trim(),
                this.selectedTerritoryType2
            );
            this.territorySuggestions2 = [];
            this.terrLevelSelected = this.selectedTerritoryType2;
            this.getData(this.terrCodeSelected, this.terrLevelSelected, 1, this.terrLabelSelected);

        },
        resetTerritorySearchPrimary() {
            this.territorySearchTerm2 = '';
            this.territorySuggestions2 = [];
            this.territorySearchError2 = '';
            this.lastTerritorySearchSignature2 = '';
        },
        scheduleTerritorySearch() {
            clearTimeout(this.territorySearchTimeout);
            const trimmedTerm = this.territorySearchTerm ? this.territorySearchTerm.trim() : '';
            if (!trimmedTerm || trimmedTerm.length < 2) {
                this.territorySuggestions = [];

                this.lastTerritorySearchSignature = '';
                return;
            }
            const searchSignature = this.createSearchSignature(trimmedTerm, this.selectedTerritoryType);
            if (searchSignature === this.lastTerritorySearchSignature) {
                return;
            }
            this.territorySearchTimeout = setTimeout(() => {
                this.fetchTerritorySuggestions(trimmedTerm, this.selectedTerritoryType, searchSignature);
            }, 300);
        },
        async fetchTerritorySuggestions(term, type, signature) {
            this.isSearchingTerritory = true;
            this.territorySearchError = '';
            this.lastTerritorySearchSignature = signature;
            try {
                const { url, params } = this.buildGeoApiSearchQuery(type, term);
                const { data } = await axios.get(url, { params });
                const currentSignature = this.createSearchSignature(
                    this.territorySearchTerm ? this.territorySearchTerm.trim() : '',
                    this.selectedTerritoryType
                );
                if (signature !== currentSignature) {
                    return;
                }
                this.territorySuggestions = Array.isArray(data) ? data.slice(0, 10) : (data ? [data] : []);
            } catch (error) {
                console.error('Territory search error', error);
                this.territorySearchError = "Impossible de récupérer les suggestions.";
                this.territorySuggestions = [];
            } finally {
                this.isSearchingTerritory = false;
            }
        },
        buildGeoApiSearchQuery(type, term) {
            const cleanTerm = term.trim();
            const isCodeLookup = /^[0-9]+$/i.test(cleanTerm);
            const params = { fields: 'nom,code' };
            const routes = {
                reg: 'https://geo.api.gouv.fr/regions',
                dep: 'https://geo.api.gouv.fr/departements',
                epci: 'https://geo.api.gouv.fr/epcis',
                com: 'https://geo.api.gouv.fr/communes'
            };
            params[isCodeLookup ? 'code' : 'nom'] = cleanTerm;
            if (type === 'com') {
                params.boost = 'population';
                params.limit = 20;
            }
            return { url: routes[type], params };
        },
        handleTerritorySuggestionSelect(suggestion) {
            this.selectedCodeTerr = suggestion.code;
            this.territorySearchTerm = `${suggestion.nom} (${suggestion.code})`;
            this.lastTerritorySearchSignature = this.createSearchSignature(
                this.territorySearchTerm.trim(),
                this.selectedTerritoryType
            );
            this.territorySuggestions = [];
            this.terrLevelRef = this.selectedTerritoryType;
            const matchType = this.territoryTypes.find(t => t.value === this.selectedTerritoryType);
            this.terrNameRef = matchType ? matchType.label : 'Territoire';
            this.handleRefChange(this.selectedCodeTerr, this.selectedTerritoryType,suggestion.nom);
        },
        resetTerritorySearch() {
            this.territorySearchTerm = '';
            this.territorySuggestions = [];
            this.territorySearchError = '';
            this.lastTerritorySearchSignature = '';
        },
        createSearchSignature(term, type = this.selectedTerritoryType) {
            const normalized = term ? term.toLowerCase() : '';
            return `${type}|${normalized}`;
        }
    }
};

</script>

<style scoped>
.bloc_stat-csv-btn {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    border-radius: 3px;
    transition: background-color 0.15s ease-in-out;
}

.territory-suggestions {
    position: absolute;
    top: calc(100% + 0.25rem);
    left: 0;
    right: 0;
    z-index: 1050;
    max-height: 240px;
    overflow-y: auto;
}

.stick-label-stats {
    background-color: #f5f8fa;
    width: fit-content;
    min-width: 100px;
    font-size: 0.7rem;
    margin-left: 5px;
    color: #7d7d7d;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    margin-bottom: -4px;
}
</style>